import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { api, fetchWithAuth } from '../config/api';
import './Login.css';

const Login = () => {
  const { login } = useAuth();
  const { t } = useLanguage();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Verificar credenciales haciendo una petición de prueba
      const testUrl = api.dmas();
      const credentials = btoa(`${username}:${password}`);
      
      // Crear un AbortController para timeout
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 segundos timeout
      
      let response;
      try {
        response = await fetch(testUrl, {
          headers: {
            'Authorization': `Basic ${credentials}`
          },
          signal: controller.signal
        });
        clearTimeout(timeoutId);
      } catch (fetchError) {
        clearTimeout(timeoutId);
        if (fetchError.name === 'AbortError') {
          throw new Error('TIMEOUT');
        }
        throw fetchError;
      }

      if (response.ok) {
        // Credenciales válidas
        const result = await login(username, password);
        if (!result.success) {
          setError(result.error || 'Could not sign in');
        }
      } else if (response.status === 401) {
        setError('Invalid username or password');
      } else {
        setError(`Server error (${response.status}). Please try again.`);
      }
    } catch (err) {
            
      let errorMessage = '';
      
      // Detectar diferentes tipos de errores
      if (err.message === 'TIMEOUT') {
        errorMessage = 'The server is not responding. Make sure it is running.';
      } else if (err.message === 'Failed to fetch' || err.name === 'TypeError' || (err.message && err.message.includes('fetch'))) {
        errorMessage = 'Cannot connect to the server. Ensure it is running at http://localhost:3002';
      } else if (err.name === 'AbortError') {
        errorMessage = 'The request took too long. Check your connection.';
      } else {
        errorMessage = `Connection error: ${err.message || 'Please try again.'}`;
      }
      
            setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <h1>{t('login.title', 'Login')}</h1>
          <p>{t('login.subtitle', 'Enter your credentials to access')}</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="login-error" role="alert">
              <strong>⚠️ Error:</strong> {error}
            </div>
          )}
          
          <div className="form-group">
            <label htmlFor="username">
              {t('login.username', 'Username')}
            </label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder={t('login.usernamePlaceholder', 'Enter your username')}
              autoComplete="username"
              required
              autoFocus
              disabled={loading}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">
              {t('login.password', 'Password')}
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t('login.passwordPlaceholder', 'Enter your password')}
              autoComplete="current-password"
              required
              disabled={loading}
            />
          </div>
          
          <button 
            type="submit" 
            className="login-button"
            disabled={loading || !username || !password}
          >
            {loading ? t('login.loggingIn', 'Signing in...') : t('login.login', 'Login')}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;

